import { useAuth as e } from "../../hooks/useAuth.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/queries/permissions/useAssignPermissionsMutation.ts
var i = (i) => {
	let { activeWorkspaceId: a } = e(), o = n();
	return t({
		mutationFn: (e) => r.assignPermissions(i, e),
		onSuccess: () => {
			o.invalidateQueries({ queryKey: [
				"permissions",
				"member",
				a,
				i
			] });
		}
	});
};
//#endregion
export { i as useAssignPermissionsMutation };
